export default function mod(n, x) {
    return ((n % x) + x) % x;
}



//////////////////
// WEBPACK FOOTER
// ./~/moment/src/lib/utils/mod.js
// module id = 584
// module chunks = 0